export const FlowContainerConstants = {
  STAGE_1_TOTAL: 'stage1Total',
  STAGE_2_TOTAL: 'stage2Total',
  STAGE_3_TOTAL: 'stage3Total',
  STAGE_4_TOTAL: 'stage4Total',
  B2B: 'b2b',
  B2C: 'b2c',
  STAGE_1_TOTAL_EMISSION: 'stage1EmissionTotal',
  STAGE_2_TOTAL_EMISSION: 'stage2EmissionTotal',
  STAGE_3_TOTAL_EMISSION: 'stage3EmissionTotal',
  STAGE_4_TOTAL_EMISSION: 'stage4EmissionTotal',
  HELP_DESK: 'Help Desk',
};
